// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1SDU0","icon":"SortAdornment_icon__3b8ox","up":"SortAdornment_up__3YEKl","down":"SortAdornment_down__1NRJD","active":"SortAdornment_active__3MjbX"};